import { useState, useEffect } from "react";
import styles from "./main-app-menu.module.css";
import { DropdownMenu } from "components/common/dropdown-menu";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";
import { ContentAdmin } from "./content-admin";
import { ContentUser } from "./content-user";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

export const MainAppMenu = () => {
  const { role, isUserAuthenticated } = useAuthContext();
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  return (
    <DropdownMenu
      label={<DropdownLabel />}
      alignment="right"
      isVisible={isDropDownOpen}
      onToggleVisibility={() => setIsDropDownOpen(!isDropDownOpen)}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          {isUserAuthenticated && (
            <>
              <div className={styles.section}>
                <ContentUser didClickOption={() => setIsDropDownOpen(false)} />
              </div>
              {role === "admin" && (
                <div className={styles.section}>
                  <ContentAdmin
                    didClickOption={() => setIsDropDownOpen(false)}
                  />
                </div>
              )}
            </>
          )}
          <p className={styles.sectionTitle}>Account</p>
          <SignInOutUp didClickOption={() => setIsDropDownOpen(false)} />
        </div>
      </div>
    </DropdownMenu>
  );
};

const DropdownLabel = () => {
  return <UIIconButton iconName="MAIN-MENU" width={30} onClick={() => {}} />;
};

interface SignInOutUpProps {
  didClickOption: () => void;
}
const SignInOutUp = (props: SignInOutUpProps) => {
  const { signIn, navigateTo } = usePaths();
  const { signOut } = useAuthContext();
  const { isUserAuthenticated } = useAuthContext();

  if (isUserAuthenticated) {
    return (
      <div className={styles.accountControls}>
        <MenuOption
          label="Sign Out"
          icon="SIGN-OUT"
          onClick={() => {
            signOut();
            props.didClickOption();
          }}
        />
      </div>
    );
  } else {
    return (
      <div className={styles.accountControls}>
        <MenuOption
          label="Sign in/up"
          icon="SIGN-IN"
          onClick={() => {
            navigateTo(signIn);
            props.didClickOption();
          }}
        />
      </div>
    );
  }
};
